/*
 * @Author: ext.shuiqianning1
 * @Date: 2022-07-01 01:08:13
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-09-30 11:11:41
 * @FilePath: /dpInquery/src/api/doctor-list.ts
 */
import { post, get } from "./utils";

// fake api url
// export const getDoctors = (param?: any) => post('jdhsm_queryUserInfo', param || {}, 'https://cnodejs.org/api/v1/topics?limit=10');
/** 查询组件信息 */
export const getDoctors = (params?: any) => get("jdhsm_queryUserInfo", params);

// 查询医生详情
export const postDoctors = (params?: any) =>
  post("health_cmp_biz_getDoctorInfoById", params);

export const postDoctorDetail = (params?: any) =>
  post(
    "NHPFCoreDoctorBasic_getSeoDoctorDetail",
    params,
    "",
    "jd_nethp_patient_h5"
  );

export const postContentDiag = (params?: any) =>
  post("health_cmp_pageContentDiag", params);

export const queryContentByDiagId = (params?: any) =>
  // post("health_cmp_queryContentByDiagId", params);
  post("jdh_queryQaDetailByDiagId", params);

export const getPageFloorElement = (params?: any) =>
  post("NHPFCorePatientIndex_getPageFloorElement", params);

export const queryArticles = (params?: any) =>
  post("JDDAPP_SF_queryArticles", params);

// 查询文章详情
export const handleSoaRequest = (params?: any) =>
  post("jdh_laputa_handleSoaRequest", params);

/**
 * 查询文章详情
 * @param params
 */
export const queryContentById = (params?: any) =>
  post("jdh_seo_querySeoContentDetails4Gw", params);
// 问诊单推荐
export const recommendContentDiag = (params?: any) =>
  post("jdh_laputa_handleSoaRequest", params);

// 批量查询医生信息
export const pageDoctorInfo = (params?: any) =>
  post("health_cmp_biz_pageDoctorInfo", params);

// 科普文章接口
export const getPopularScienceArticles = (params?: any) =>
  post("jdh_laputa_handleSoaRequest", params);
// 患友问诊接口
export const getPatientConsultation = (params?: any) =>
  post("jdh_laputa_handleSoaRequest", params);
// 黄页医生详情  排班信息
export const queryYellowPagesDoctorDetail = (params?: any) => {
  if (params.yellowpagesDocId && params.yellowpagesDocId.indexOf("_") > -1) {
    params.yellowpagesDocId = params.yellowpagesDocId.split("_")[0];
  }
  return post("NHPFCore_queryYellowPagesDoctorDetail", params);
};
// 黄页医生推荐列表
export const queryDoctorList = (params?: any) =>
  post("NHPFCoreDoctorList_queryDoctorList", params);

// 医院信息获取
export const queryTabDoctorList = (params?: any) =>
  post("NHPFCore_excuteFassScript", params, "", "jd_nethp_patient_h5").then(
    (data) => {
      //  天空之城需要的结构需要code码，做了兼容renmin
      return {
        code: "0000",
        msg: "OK",
        success: true,
        data,
      };
    }
  );
